import React, { Component } from "react";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingCircular from "../LoadingCircular";

class MasrafKonandehForm extends Component {
  state = {
    step: 1,
    isLoading: false,
    isHaghighi: true,
    nameFamily: "",
    zamineFaliat: "",
    address: "",
    telephone: "",
    mobile: "",
    email: "",
    foroshgah: "",
    sabegheFaliat: "",
    foroshOmde: false,
    foroshJoze: false,
    nameSazman: "",
    posteSazmani: "",
    noeMasraf: "",
    daryaftNemune: false,
    analysis: false,
    taminMavadAvalie: false,
    tablighat: false,
    catalog: false,
    kharideZayeat: false,
    sefareshMahsul: "",
    enteghadPishnahad: "",
  };
  onSubmit = async (e) => {
    e.preventDefault();
    if (
      this.state.nameFamily === "" ||
      this.state.address === "" ||
      this.state.mobile === ""
    ) {
      alert("لطفا موارد ستاره دار را تکمیل نمایید");
      return;
    }
    //send to api
    const masrafKonandehForm = {
      UserMobile: this.props.mobileNumber,
      NameFamily: this.state.nameFamily,
      ZamineFaliat:
        this.state.zamineFaliat === "" ? null : this.state.zamineFaliat,
      Address: this.state.address === "" ? null : this.state.address,
      Telephone: this.state.telephone === "" ? null : this.state.telephone,
      Mobile: this.state.mobile === "" ? null : this.state.mobile,
      Email: this.state.email === "" ? null : this.state.email,
      Foroshgah: this.state.foroshgah === "" ? null : this.state.foroshgah,
      SabegheFaliat:
        this.state.sabegheFaliat === "" ? null : this.state.sabegheFaliat,
      ForoshOmde: this.state.foroshOmde,
      ForoshJoze: this.state.foroshJoze,
      NameSazman: this.state.nameSazman === "" ? null : this.state.nameSazman,
      PosteSazmani:
        this.state.posteSazmani === "" ? null : this.state.posteSazmani,
      NoeMasraf: this.state.noeMasraf === "" ? null : this.state.noeMasraf,
      DaryaftNemune: this.state.daryaftNemune,
      Analysis: this.state.analysis,
      TaminMavadAvalie: this.state.taminMavadAvalie,
      Tablighat: this.state.tablighat,
      Catalog: this.state.catalog,
      KharideZayeat: this.state.kharideZayeat,
      SefareshMahsul:
        this.state.sefareshMahsul === "" ? null : this.state.sefareshMahsul,
      EnteghadPishnahad:
        this.state.enteghadPishnahad === ""
          ? null
          : this.state.enteghadPishnahad,
    };
    this.setState({ isLoading: true });
    const res = await fetch("/ng/api/Consumers", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(masrafKonandehForm),
    });
    const dataBack = await res.json();
    this.setState({ isLoading: false });
    if (dataBack.Result === "Ok") {
      this.setState({ step: 2 });
    } else {
      alert("پاسخی از سرور دریافت نشد");
    }
  };
  render() {
    const { step, isLoading } = this.state;
    switch (step) {
      case 1:
        return (
          <Stack
            component="form"
            spacing={1.5}
            noValidate
            autoComplete="off"
            onSubmit={this.onSubmit}
          >
            <LoadingCircular open={isLoading} />
            <Typography variant="h6" sx={{ textAlign: "center" }}>
              ثبت اطلاعات مصرف کننده
            </Typography>
            <TextField
              required
              label="نام و خانوادگی"
              variant="standard"
              onChange={(e) => {
                this.setState({ nameFamily: e.target.value });
              }}
            />
            <TextField
              label="زمینه فعالیت"
              variant="standard"
              onChange={(e) => {
                this.setState({ zamineFaliat: e.target.value });
              }}
            />
            <TextField
              required
              label="آدرس"
              variant="standard"
              multiline
              onChange={(e) => {
                this.setState({ address: e.target.value });
              }}
            />

            <TextField
              label="تلفن"
              variant="standard"
              type="tel"
              onChange={(e) => {
                this.setState({ telephone: e.target.value });
              }}
            />
            <TextField
              required
              label="تلفن همراه"
              variant="standard"
              type="tel"
              onChange={(e) => {
                this.setState({ mobile: e.target.value });
              }}
            />
            <TextField
              label="ایمیل / وبسایت"
              variant="standard"
              type="email"
              onChange={(e) => {
                this.setState({ email: e.target.value });
              }}
            />
            <FormControl>
              {/* <FormLabel id="isHaghighi"> تاهل</FormLabel> */}
              <RadioGroup
                row
                defaultValue="1"
                aria-labelledby="isHaghighi"
                name="radio-buttons-group"
                onChange={(e) => {
                  this.setState({
                    isHaghighi: e.target.value === "1" ? true : false,
                  });
                }}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="شخص حقیقی"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="شخص حقوقی"
                />
              </RadioGroup>
            </FormControl>
            {this.state.isHaghighi ? (
              <>
                <TextField
                  label="نام فروشگاه"
                  variant="standard"
                  onChange={(e) => {
                    this.setState({ foroshgah: e.target.value });
                  }}
                />
                <TextField
                  label="سابقه فعالیت"
                  variant="standard"
                  onChange={(e) => {
                    this.setState({ sabegheFaliat: e.target.value });
                  }}
                />
                <FormControl
                  sx={{ m: 3 }}
                  component="fieldset"
                  variant="standard"
                >
                  <FormLabel component="legend">نوع فروش</FormLabel>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.foroshOmde}
                          onChange={(e) => {
                            this.setState({ foroshOmde: e.target.checked });
                          }}
                        />
                      }
                      label="عمده"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.foroshJoze}
                          onChange={(e) => {
                            this.setState({ foroshJoze: e.target.checked });
                          }}
                        />
                      }
                      label="جزئی"
                    />
                  </FormGroup>
                </FormControl>
              </>
            ) : (
              <>
                <TextField
                  label="نام سازمان/شرکت"
                  variant="standard"
                  onChange={(e) => {
                    this.setState({ nameSazman: e.target.value });
                  }}
                />
                <TextField
                  label="پست سازمانی"
                  variant="standard"
                  onChange={(e) => {
                    this.setState({ posteSazmani: e.target.value });
                  }}
                />
                <TextField
                  label="نوع مصرف"
                  variant="standard"
                  onChange={(e) => {
                    this.setState({ noeMasraf: e.target.value });
                  }}
                />
              </>
            )}
            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
              <FormLabel component="legend">درخواست</FormLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.daryaftNemune}
                      onChange={(e) => {
                        this.setState({ daryaftNemune: e.target.checked });
                      }}
                    />
                  }
                  label="دریافت نمونه"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.analysis}
                      onChange={(e) => {
                        this.setState({ analysis: e.target.checked });
                      }}
                    />
                  }
                  label="آنالیز"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.taminMavadAvalie}
                      onChange={(e) => {
                        this.setState({ taminMavadAvalie: e.target.checked });
                      }}
                    />
                  }
                  label="تامین مواد اولیه"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.tablighat}
                      onChange={(e) => {
                        this.setState({ tablighat: e.target.checked });
                      }}
                    />
                  }
                  label="تبلیغات"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.catalog}
                      onChange={(e) => {
                        this.setState({ catalog: e.target.checked });
                      }}
                    />
                  }
                  label="کاتالوگ"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.kharideZayeat}
                      onChange={(e) => {
                        this.setState({ kharideZayeat: e.target.checked });
                      }}
                    />
                  }
                  label="خرید ضایعات"
                />
              </FormGroup>
            </FormControl>
            <TextField
              label="سفارش محصول"
              variant="standard"
              onChange={(e) => {
                this.setState({ sefareshMahsul: e.target.value });
              }}
            />
            <TextField
              label="انتقاد و پیشنهاد"
              variant="standard"
              multiline
              onChange={(e) => {
                this.setState({ enteghadPishnahad: e.target.value });
              }}
            />
            <Button type="submit" variant="contained">
              ثبت
            </Button>
          </Stack>
        );
      case 2:
        return (
          <Typography sx={{ textAlign: "center" }}>
            اطلاعات شما با موفقیت ارسال شد
          </Typography>
        );
      default:
    }
  }
}

export default MasrafKonandehForm;
